import PropTypes from "prop-types";
import {
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
} from "@mui/material";
import Card from "../../components/Cards/Card";
import styled from "styled-components";
import NativeObject from "../../components/NativeObject/NativeObject";
import { useCallback, useEffect, useState } from "react";
import { useSelections } from "../../context/Selections";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import PDF from "./Regras-Incentivos-Programa-de-Excelência-FY25.pdf";

import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

const LayoutCardsWrapper = styled("div")({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  justifyContent: "flex-start",
  width: "100%",
});

function RankingDesktop({ app, config }) {
  const [selectedValue, setSelectedValue] = useState("Pontuação");
  const [selectedValueRanking, setSelectedValueRanking] =
    useState("Ranking Geral");
  const [namePeriodo, setNamePreiodo] = useState();
  const [showRanking, setShowRanking] = useState();
  const [showPDF, setShowPDF] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState("");
  const [singleGroupView, setSingleGroupView] = useState(false);
  const { selections } = useSelections();

  const history = useHistory();

  const transformObjectValueInString = useCallback(
    async (objectId) => {
      if (app && objectId) {
        let id = objectId;
        await app.visualization.get(id).then((res) => {
          const value =
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qText ??
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qNum ??
            null;

          setNamePreiodo(value);
        });
      }
    },
    [app]
  );

  const validateShowRanking = useCallback(
    async (objectId) => {
      if (app && objectId) {
        let id = objectId;
        await app.visualization.get(id).then((res) => {
          const value =
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qText ??
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qNum ??
            null;

          setShowRanking(value);
        });
      }
    },
    [app]
  );

  const handleChange = (event) => {
    app.field("Nm_Visu_Rank").selectMatch(event.target.value, true);
    setSelectedValue(event.target.value);
  };

  const handleChangeRanking = (event) => {
    app.field("Nm_Rank").selectMatch(event.target.value, true);
    setSelectedValueRanking(event.target.value);
  };

  // Função para rolar até o card do PDF
  const scrollToPDFCard = () => {
    const element = document.getElementById("pdf");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    if (app) {
      const distributors = selections.length
        ? selections.find((s) => s.qField === "Nm_Visu_Rank")
        : null;
      setSelectedGroup(
        distributors
          ? distributors?.qSelectedCount === 1
            ? `: ${distributors.qSelected}`
            : ""
          : ""
      );
      setSingleGroupView(distributors?.qSelectedCount === 1);

      setSelectedValue(distributors?.qSelected);

      transformObjectValueInString("vvkXXx");
      validateShowRanking("RMHbJk");
    }
  }, [
    namePeriodo,
    app,
    transformObjectValueInString,
    selections,
    validateShowRanking,
  ]);

  useEffect(() => {
    if (app) {
      const distributors = selections.length
        ? selections.find((s) => s.qField === "Nm_Rank")
        : null;
      setSelectedGroup(
        distributors
          ? distributors?.qSelectedCount === 1
            ? `: ${distributors.qSelected}`
            : ""
          : ""
      );

      setSelectedValueRanking(distributors?.qSelected);
    }
  }, [app, selections]);

  useEffect(() => {
    if (app) {
      showRanking === "0" && history.push("/resumo");
    }
  }, [app, history, selections, showRanking]);

  return (
    <div className="app ranking">
      <div className="appContent">
        <LayoutCardsWrapper>
          <div className="container-titles">
            <h3
              style={{ marginTop: "8px" }}
              onClick={() => history.push("/resumo")}
            >
              Ranking
            </h3>

            <p>
              <span>Período analisado</span>
              <span className="name-periodo-analisado">{namePeriodo}</span>
            </p>
          </div>

          <Grid className="container-form-and-button">
            <FormControl className="container-form-control">
              <RadioGroup
                defaultValue="Total"
                row
                name="row-radio-buttons-group"
                className="radio-group radio-group-button-export"
                value={selectedValueRanking}
                onChange={handleChangeRanking}
                sx={{ margin: "0px 0 25px 0" }}
              >
                <FormControlLabel
                  value="Ranking Geral"
                  control={
                    <Radio
                      size="small"
                      defaultChecked
                      sx={{
                        color: "#0DA9D5",
                        "&.Mui-checked": {
                          color: "#0DA9D5",
                        },
                      }}
                    />
                  }
                  label="Ranking Geral"
                />

                <FormControlLabel
                  value="Ranking Detalhado"
                  control={
                    <Radio
                      size="small"
                      sx={{
                        color: "#0DA9D5",
                        "&.Mui-checked": {
                          color: "#0DA9D5",
                        },
                      }}
                    />
                  }
                  label="Ranking Detalhado"
                />
              </RadioGroup>
            </FormControl>

            <div className="container-button-pdf">
              <Button
                onClick={() => {
                  setShowPDF((old) => !old);
                  setTimeout(() => scrollToPDFCard(), 200);
                }}
                className="button-see-pdf"
                startIcon={
                  showPDF ? (
                    <VisibilityOffOutlinedIcon />
                  ) : (
                    <RemoveRedEyeOutlinedIcon />
                  )
                }
              >
                {showPDF
                  ? "Ocultar REGRAS INCENTIVE"
                  : "VISUALIZAR REGRAS INCENTIVE"}
              </Button>
            </div>
          </Grid>

          {selectedValueRanking === "Ranking Geral" && (
            <Grid container flexDirection={"column"}>
              <Grid item>
                <Card
                  app={app}
                  style={{
                    width: "100%",
                  }}
                  header={{
                    hardTitle: "Ranking Geral",
                  }}
                  exportContainer
                  exportTable
                  exportTableId="JacaZ"
                >
                  <NativeObject
                    app={app}
                    key="JacaZ"
                    reference={{
                      id: "JacaZ",
                    }}
                    style={{
                      height: "450px",
                      with: "100%",
                    }}
                  />
                </Card>
              </Grid>
            </Grid>
          )}

          {selectedValueRanking === "Ranking Detalhado" && (
            <Grid container flexDirection={"column"}>
              <Grid item className="container-line-one">
                <Card
                  header={{
                    hardTitle: "Ranking por KPIs",
                  }}
                  exportContainer
                  exportTable
                  exportTableId="HbwcKWJ"
                  className="card-one"
                >
                  <FormControl className="container-form-control">
                    <RadioGroup
                      defaultValue="Total"
                      row
                      name="row-radio-buttons-group"
                      className="radio-group radio-group-button-export"
                      value={selectedValue}
                      onChange={handleChange}
                      sx={{ marginLeft: "12px", marginBottom: "20px" }}
                    >
                      <FormControlLabel
                        value="Total"
                        control={
                          <Radio
                            size="small"
                            defaultChecked
                            sx={{
                              color: "#0DA9D5",
                              "&.Mui-checked": {
                                color: "#0DA9D5",
                              },
                            }}
                          />
                        }
                        label="Total"
                      />

                      <FormControlLabel
                        value="Estrutural"
                        control={
                          <Radio
                            size="small"
                            sx={{
                              color: "#0DA9D5",
                              "&.Mui-checked": {
                                color: "#0DA9D5",
                              },
                            }}
                          />
                        }
                        label="Estrutural"
                      />

                      <FormControlLabel
                        value="Performance"
                        control={
                          <Radio
                            size="small"
                            sx={{
                              color: "#0DA9D5",
                              "&.Mui-checked": {
                                color: "#0DA9D5",
                              },
                            }}
                          />
                        }
                        label="Performance"
                      />
                    </RadioGroup>
                  </FormControl>

                  <NativeObject
                    app={app}
                    key="HbwcKWJ"
                    reference={{
                      id: "HbwcKWJ",
                    }}
                    style={{
                      width: "100%",
                      height: "500px",
                    }}
                    className={"container-boject-score"}
                  />
                </Card>

                <Card
                  app={app}
                  style={{
                    width: "50%",
                  }}
                  header={{
                    hardTitle: "Ranking por Venda Excelente",
                  }}
                  exportContainer
                  exportTable
                  exportTableId="jpFhk"
                  className="card-two"
                >
                  <NativeObject
                    app={app}
                    key="jpFhk"
                    reference={{
                      id: "jpFhk",
                    }}
                    style={{
                      height: "100%",
                      with: "100%",
                    }}
                  />
                </Card>
              </Grid>
            </Grid>
          )}

          {showPDF && (
            <Card style={{ width: "100%" }} className="container-pdf">
              <Button
                onClick={() => setShowPDF(false)}
                className="button-see-pdf"
                endIcon={<CloseOutlinedIcon sx={{ color: "black" }} />}
              />

              <iframe
                title="pdf-regras-da-campanha"
                height={"700px"}
                width={"100%"}
                id="pdf"
                style={{ margin: "auto" }}
                src={PDF}
              />
            </Card>
          )}
        </LayoutCardsWrapper>
      </div>
    </div>
  );
}

RankingDesktop.defaultProps = {
  app: null,
  config: {},
};

RankingDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default RankingDesktop;
